import { InjectionToken } from '@angular/core';

export enum FallbackImage {
    Default = 'fallback',
    EpcotDefault = 'epcot_fallback',
}

export interface ParticipantImageConfig {
    fallbackImage: FallbackImage;
}

export const PARTICIPANT_IMAGE_CONFIG = new InjectionToken<ParticipantImageConfig>('PARTICIPANT_IMAGE_CONFIG');
